import {
  put,
  takeLatest,
  select,
  cancel,
  fork,
  delay,
} from 'redux-saga/effects';

import { consts as joinPopupConst } from '../joinPopup';
import { consts as reqMemberInvitation } from '../reqMemberInvitation';
import { communityJoinPopupSelector } from '../selectors/selectors';

function* joinCommunityPopupWorker(action) {
  const { payload } = action;
  yield delay(payload.delay);
  const joinPopup = yield select(communityJoinPopupSelector);
  const { visible, content, timer } = joinPopup;
  const isSignUpPopupOpen = visible && content === ('signUp' || 'success');

  if (!timer || isSignUpPopupOpen) {
    yield cancel();
  }

  yield put({
    type: joinPopupConst.STOP_TIMER,
  });
  yield put({
    type: joinPopupConst.SHOW,
    payload: {
      content: 'join',
    },
  });
}

function* joinCommunityPopupSaga() {
  yield takeLatest(joinPopupConst.SET_TIMER, joinCommunityPopupWorker);
}

function* succeedInvitePopupWorker() {
  yield put({
    type: joinPopupConst.SHOW,
    payload: {
      content: 'success',
    },
  });
}

function* succeedInvitePopupSaga() {
  yield takeLatest(reqMemberInvitation.SUCCEED, succeedInvitePopupWorker);
}

export default function* root() {
  yield fork(joinCommunityPopupSaga);
  yield fork(succeedInvitePopupSaga);
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/joinCommunityPopup.js